// common imports
import ArrowRight from "common/svg/ArrowRight";
import ArrowLeft from "common/svg/ArrowLeft";

// styled-components imports
import Container from "./styled-components/Container";
import Content from "./styled-components/Content";
import PageIndicator from "./styled-components/PageIndicator";
import PaginationHeader from "./styled-components/PaginationHeader";

import Navigation from "./styled-components/Navigation";
import NavigationButton from "./styled-components/NavigationButton";

interface PaginationProps {
  children: React.ReactNode;
  page: number;
  total: number;
  handleNext(): void;
  handleBack(): void;
}

function Pagination({
  page,
  total,
  handleNext,
  handleBack,
  children,
}: PaginationProps) {
  return (
    <Container>
      <PaginationHeader>
        <PageIndicator>
          {page}/{total}
        </PageIndicator>
      </PaginationHeader>
      <Content>{children}</Content>
      <Navigation>
        {page > 1 && (
          <NavigationButton onClick={handleBack} navAction="back">
            <ArrowLeft size={25} />
            &nbsp;Atrás
          </NavigationButton>
        )}
        {page < total && (
          <NavigationButton onClick={handleNext} navAction="next">
            Siguiente&nbsp;
            <ArrowRight size={25} />
          </NavigationButton>
        )}
      </Navigation>
    </Container>
  );
}

export default Pagination;
